import React from 'react';
import { regions } from '../../data/regions'

export const AmazonPriceSetterScreen = (props) => {

  return (
    <div className='text-center mt-5'>
      <div>
        <div>Paste delisting data</div>
        <textarea value={props.inputContents} onChange={props.onInputData}></textarea>
      </div>
      <div>
        <div>Paste Amazon Inventory Report</div>
        <textarea value={props.amazonReportContents} onChange={props.onInputAmazonReport}></textarea>
      </div>
      <div>
        <button onClick={props.onClickConfirm} disabled={props.processing}>Confirm</button>
      </div>
      <div>
      {props.processing && <div>PROCESSING CAN TAKE 20 MINS+</div>}
        <div>
          <div>All data output</div>

          <textarea
            readOnly
            value={props.outputContents.map((product) => {
              return (
                '\n' +
                Object.values(product).map((attribute) => {
                  if (typeof attribute === 'object' && attribute !== null) {
                    return Object.values(attribute).map((subAttribute) => {
                      return subAttribute;
                    });
                  }
                  return attribute;
                })
              );
            })}
          ></textarea>
          <div>Output for Profit Protector Pro</div>
          <textarea
            readOnly
            value={
              [
                'Channel Account Name',
                'SKU',
                'ASIN',
                'Item Title',
                'Repricing ON',
                'Acquisition Cost',
                'Total Minimum',
                'Total Maximum'
                // 'Repricing Profile',
                // 'SKU',
                // 'ASIN',
                // 'MinPrice',
                // 'MaxPrice',
                // 'BuyPrice',
                // 'BreakEvenPrice',
                // 'MarketplaceID',
                // 'StrategyID',
                // 'CustomStrategyName',
                // 'Title',
              ].join('\t') +
              regions.map((region) => {
                return props.outputContents.map((product) => {
                  //products without cost price will be priced incorrectly. Products without asin will invalidate Profit Protector upload
                  if (product.costPrice <= 0 || !Boolean(product.asin)) {
                    return
                  }
                  const arr = [
                    `merchoid${region.toUpperCase()}`,
                    product.id,
                    product.asin,
                    product.name,
                    'true',
                    parseFloat(product.costPrice).toFixed(2),
                    parseFloat(product[region].minPrice).toFixed(2),
                    parseFloat(product[region].maxPrice).toFixed(2),
                  ];
                  return '\n' + arr.join('\t');
                });
              })
            }
          ></textarea>
        </div>
      </div>
    </div>
  );
};
